import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {EMPTY, Observable, of} from 'rxjs';
import { map, mergeMap, catchError,switchMap } from 'rxjs/operators';
import { AccountsService } from '../accounts.service';
import * as AcccountActions from './accounts.actions';

@Injectable()
export class AccountEffects {

  /*
  {type: '[Accounts Component] Load Accounts', payload: 'account/agency/agcydfca059b00744c838b4484268ed792f6'}
  is a object of type and payload which is a string
   */

  getAccounts$ = createEffect(() => this.actions$.pipe(
      ofType(AcccountActions.LOAD_ACCOUNTS,AcccountActions.LOADING),
      mergeMap((payload:string) => this.accountsService.getAccounts(payload['payload'])
        .pipe(
          map(accounts => ({ type: AcccountActions.ADD_ACCOUNTS, payload: accounts })),
          //map(accounts => (console.log('fdgsfgsfgsdfgsfdgsfgsdfg',payload),{ type: AcccountActions.ADD_ACCOUNTS, payload: accounts })),
          catchError((error) => {
            console.log('error',error);
            return of({ type: AcccountActions.LOAD_ACCOUNTS_ERROR, payload: error });
          })
        ))
    ) //end outer pipe s
  );

  getAccount$ = createEffect(() => this.actions$.pipe(
      ofType(AcccountActions.LOAD_ACCOUNT),
      mergeMap((payload:string) => this.accountsService.get(payload['payload'])
        .pipe(
          map(accounts => ({ type: AcccountActions.ADD_ACCOUNT, payload: accounts })),
          //map(accounts => (console.log('fdgsfgsfgsdfgsfdgsfgsdfg',payload),{ type: AcccountActions.ADD_ACCOUNTS, payload: accounts })),
          catchError((error) => {
            console.log('error',error);
            return of({ type: AcccountActions.LOAD_ACCOUNT_ERROR, payload: error });
          })
        ))
    ) //end outer pipe s
  );

  // addAccount$ = createEffect(() => this.actions$.pipe(
  //     ofType(AcccountActions.LOAD_ADD_ACCOUNT),
  //
  //     mergeMap((payload:string) => this.accountsService.post(payload['payload']['endpoint'],payload['payload']['data'])
  //       .pipe(
  //         map(accounts => ({ type: AcccountActions.ADD_ACCOUNT, payload: payload['payload']['data'] })),
  //         catchError((error) => {
  //           console.log('error in EFFECTS',error);
  //           return of({ type: AcccountActions.LOAD_ADD_ACCOUNT_ERROR, payload: error })
  //         }
  //         )
  //       ))
  //   ) //end outer pipe s
  // );

  addAccount$ = createEffect(() =>this.actions$.pipe(
      ofType(AcccountActions.LOAD_ADD_ACCOUNT),
      switchMap((payload:string) =>
        this.accountsService.post(payload['payload']['endpoint'],payload['payload']['data']).pipe(
          map(accounts => (
            console.log('EFFECTS ADD ACCOUNT PAYLOAD',accounts),
            { type: AcccountActions.ADD_ACCOUNT, payload: payload['payload']['data'] }
          )),
          catchError((error) => {
            console.log('EFFECTS catchError',error);
            return of({ type: AcccountActions.LOAD_ADD_ACCOUNT_ERROR, payload: error })
          }
          )
        )
    )//end switchMap
  ) //end pipe
  );//end createEffect


  updateAccount$ = createEffect(() => this.actions$.pipe(
      ofType(AcccountActions.LOAD_UPDATE_ACCOUNT),
      mergeMap((payload:string) => this.accountsService.put(payload['payload']['endpoint'],payload['payload']['account'])
        .pipe(
          map(accounts => (console.log('WWWWWWWWWWWWWWWWW'),{ type: AcccountActions.UPDATE_ACCOUNT, payload: {account:payload['payload']['account'],index:payload['payload']['index']} })),
          catchError(() => of( { type: AcccountActions.LOAD_UPDATE_ACCOUNT_ERROR })),

        ))
    ) //end outer pipe s
  );

  deleteAccount$ = createEffect(() => this.actions$.pipe(
      ofType(AcccountActions.LOAD_DELETE_ACCOUNT),
      mergeMap((payload:string) => this.accountsService.delete(payload['payload']['endpoint'])
        .pipe(
          map(accounts => ({ type: AcccountActions.DELETE_ACCOUNT, payload: payload['payload']['index'] })),
          catchError(() => EMPTY)
        ))
    ) //end outer pipe s
  );

  constructor(
    private actions$: Actions,
    private accountsService: AccountsService
  ) {}
}
